import axios from "../axiosApi";
import config from "../../config";
import {
    FETCH_PERSON_DOCUMENTS,
    RECEIVE_PERSON_DOCUMENTS,
    FETCH_DOCUMENT_TYPES,
    RECEIVE_DOCUMENT_TYPES,
    UPLOAD_PERSON_DOCUMENT,
    UPLOAD_PERSON_DOCUMENT_SUCCESS,
    DELETE_PERSON_DOCUMENT,
    DELETE_PERSON_DOCUMENT_SUCCESS,
} from "../actionTypes";

const MINIO_BUCKET = (config as any).MINIO_BUCKET || 'fermi-docs';

// --- Document Types ---

export const getDocumentTypes = () => {
    return async (dispatch: any) => {
        dispatch({ type: FETCH_DOCUMENT_TYPES });
        try {
            const filter = JSON.stringify({ where: { active: true }, order: 'order ASC' });
            const response = await axios.get(`/DocumentTypes?filter=${filter}`);
            dispatch({ type: RECEIVE_DOCUMENT_TYPES, payload: response.data });
        } catch (e) {
            console.error("getDocumentTypes ERROR", e);
            dispatch({ type: RECEIVE_DOCUMENT_TYPES, payload: [] });
        }
    };
};

// --- Person Documents ---

export const getPersonDocuments = (personId: number) => {
    return async (dispatch: any) => {
        dispatch({ type: FETCH_PERSON_DOCUMENTS });
        try {
            const filter = JSON.stringify({
                where: { personId },
                include: 'documentType',
                order: 'uploadDate DESC'
            });
            const response = await axios.get(`/PersonDocuments?filter=${filter}`);
            dispatch({ type: RECEIVE_PERSON_DOCUMENTS, payload: response.data });
        } catch (e) {
            console.error("getPersonDocuments ERROR", e);
            dispatch({ type: RECEIVE_PERSON_DOCUMENTS, payload: [] });
        }
    };
};

export const uploadPersonDocument = (
    personId: number,
    documentTypeId: number,
    file: File
) => {
    return async (dispatch: any) => {
        dispatch({ type: UPLOAD_PERSON_DOCUMENT });
        try {
            // 1. Upload file to MinIO via PersonDocumentContainer
            const formData = new FormData();
            formData.append('file', file);

            const uploadUrl = `/PersonDocumentContainers/${MINIO_BUCKET}/upload`;
            const uploadResponse = await axios.post(uploadUrl, formData, {});
            const fileData = uploadResponse.data.result.files.file[0];

            // 2. Create metadata record
            const docData: iPersonDocument = {
                personId,
                documentTypeId,
                fileName: fileData.name,
                originalName: file.name,
                fileSize: file.size,
                mimeType: file.type,
                uploadDate: new Date(),
            };

            await axios.post('/PersonDocuments', docData);

            dispatch({ type: UPLOAD_PERSON_DOCUMENT_SUCCESS });

            // 3. Refresh document list
            dispatch(getPersonDocuments(personId));
        } catch (e) {
            console.error("uploadPersonDocument ERROR", e);
            dispatch({ type: UPLOAD_PERSON_DOCUMENT_SUCCESS });
            throw e;
        }
    };
};

export const deletePersonDocument = (documentId: number, personId: number) => {
    return async (dispatch: any) => {
        dispatch({ type: DELETE_PERSON_DOCUMENT });
        try {
            await axios.delete(`/PersonDocuments/deleteDocument?id=${documentId}`);
            dispatch({ type: DELETE_PERSON_DOCUMENT_SUCCESS });
            dispatch(getPersonDocuments(personId));
        } catch (e) {
            console.error("deletePersonDocument ERROR", e);
            dispatch({ type: DELETE_PERSON_DOCUMENT_SUCCESS });
            throw e;
        }
    };
};

export const getDocumentDownloadUrl = (fileName: string): string => {
    return `${(config as any).BASE_URL}/PersonDocumentContainers/${MINIO_BUCKET}/download/${encodeURIComponent(fileName)}`;
};

// --- Document Types CRUD (Admin) ---

export const getAllDocumentTypes = () => {
    return async (dispatch: any) => {
        dispatch({ type: FETCH_DOCUMENT_TYPES });
        try {
            const filter = JSON.stringify({ order: 'order ASC' });
            const response = await axios.get(`/DocumentTypes?filter=${filter}`);
            dispatch({ type: RECEIVE_DOCUMENT_TYPES, payload: response.data });
        } catch (e) {
            console.error("getAllDocumentTypes ERROR", e);
            dispatch({ type: RECEIVE_DOCUMENT_TYPES, payload: [] });
        }
    };
};

export const saveDocumentType = (data: iDocumentType) => {
    return async (dispatch: any) => {
        try {
            if (data.id) {
                await axios.put(`/DocumentTypes/${data.id}`, data);
            } else {
                await axios.post('/DocumentTypes', data);
            }
            dispatch(getAllDocumentTypes());
        } catch (e) {
            console.error("saveDocumentType ERROR", e);
            throw e;
        }
    };
};

export const deleteDocumentType = (id: number) => {
    return async (dispatch: any) => {
        try {
            await axios.delete(`/DocumentTypes/${id}`);
            dispatch(getAllDocumentTypes());
        } catch (e) {
            console.error("deleteDocumentType ERROR", e);
            throw e;
        }
    };
};
